import { useState, useEffect, useContext } from "react";
import DeviceOrientationContext from "../../../../components/context/DeviceOrientationContext";
import { View } from "../../../../components/shared/Themed";
import { useSelector } from "react-redux";
import CompanyLogo from "../../../../components/core/CompanyLogo";
import Spinner from "../../../../components/shared/Spinner";
import AdminTopTabNavigator from "./AdminTopTabNavigator";

export default function AdminRootTabNavigator({ navigation }: any) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const { isSmallDevice } = useContext(DeviceOrientationContext);
  const { isAuthenticated } = useSelector((state: any) => state.admin);

  useEffect(() => {
    if (!isAuthenticated) {
      navigation.navigate("AdminLogin");
    }
  }, [isAuthenticated]);

  return (
    <View
      style={{
        height: "100%",
        flexDirection: "row",
      }}
    >
      {isAuthenticated && !isLoading ? (
        <View
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          {!isSmallDevice && <CompanyLogo />}
          <AdminTopTabNavigator />
          {isSmallDevice && <CompanyLogo />}
        </View>
      ) : (
        <View
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner
            size="small"
            color="#00ff00"
            styles={{
              flexDirection: "row",
              justifySelf: "center",
              alignSelf: "center",
            }}
          />
        </View>
      )}
    </View>
  );
}
